angular.module('impactx.cancellation').controller('CancelItemController', [
    '$scope',
    'ColorUtilService',
    CancelItemController]);

function CancelItemController($scope, ColorUtilService) {
    $scope.offSetForBasketItemGroupColor = 15;

    if ($scope.item.basketItemGroupId) {
        var color = ColorUtilService.getColor($scope.item.basketItemGroupId + $scope.offSetForBasketItemGroupColor);
        $scope.colorBasketItemGroup = {'border-left-color': color};
    }
    else {
        $scope.colorBasketItemGroup = {'border-left-color': 'transparent'};
    }


    $scope.extendBorderBasketItemGroup = function () {
        var element = document.getElementsByClassName('basket-item-group-' + ($scope.item.basketItemGroupId + $scope.offSetForBasketItemGroupColor));
        var jqElement = angular.element(element);
        angular.forEach(jqElement, function (aElement) {
            aElement.style['border-left-width'] = '6px';
        });
    };
    $scope.shrinkBorderBasketItemGroup = function () {
        var element = document.getElementsByClassName('basket-item-group-' + ($scope.item.basketItemGroupId + $scope.offSetForBasketItemGroupColor));
        var jqElement = angular.element(element);
        angular.forEach(jqElement, function (aElement) {
            aElement.style['border-left-width'] = '3px';
        });
    };
}